/* SDS-13: keeps the chosen-date block (snippets/sds-order-date.liquid) in step with the cart.
   Archetype's CartForm rebuilds the items of the cart drawer and of the cart page from
   /cart?view=ajax (templates/cart.ajax.liquid) on every page load with a drawer and after every
   add, quantity change and removal: it empties [data-products] and puts the response's
   .cart__items in it. That .cart__items carries, in an inert <template data-sds-order-date-source>,
   the block rendered from the same cart. A MutationObserver on each cart form's [data-products]
   copies it into the form's [data-sds-order-date], so the block always matches the items shown,
   with no extra request and nothing hooked into the theme's code. */
(function () {
  if (typeof MutationObserver === 'undefined' || !('content' in document.createElement('template'))) return;

  var SLOT = '[data-sds-order-date]';
  var SOURCE = 'template[data-sds-order-date-source]';

  function sync(form, products) {
    var source = products.querySelector(SOURCE);
    var slot = form.querySelector(SLOT);
    if (!source || !slot) return;
    var fresh = source.content.querySelector(SLOT);
    if (fresh) {
      if (slot.innerHTML !== fresh.innerHTML) slot.innerHTML = fresh.innerHTML;
    } else if (slot.innerHTML !== '') {
      // The block is switched off in the response: show nothing rather than a stale date.
      slot.innerHTML = '';
    }
  }

  function watch(form) {
    if (!form || form.hasAttribute('data-sds-order-date-watched')) return;
    var products = form.querySelector('[data-products]');
    if (!products || !form.querySelector(SLOT)) return;
    form.setAttribute('data-sds-order-date-watched', '');
    new MutationObserver(function () {
      try {
        sync(form, products);
      } catch (e) {
        // Leave the cart as the theme built it.
      }
    }).observe(products, { childList: true });
    // The theme may already have rebuilt the items before this script ran.
    sync(form, products);
  }

  function init() {
    var slots = document.querySelectorAll(SLOT);
    for (var i = 0; i < slots.length; i++) watch(slots[i].closest('form'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
